import styled from 'styled-components';
import { Colors, fonts } from '../style/GlobalStyles';

const Wrap = styled.footer`
  max-width: 1320px;
  margin: 0 auto;
  padding: 5rem 2rem 3rem 2rem;

  @media (max-width: 868px) {
    padding: 3rem 1.25rem 2rem 1.25rem;
  }
`;

const Top = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 2rem;
  padding-bottom: 4rem;

  @media (max-width: 820px) {
    flex-direction: column;
    gap: 2rem;
  }
`;

const Brand = styled.div`
  font-family: ${fonts.display};
  text-transform: uppercase;
  font-size: 1.3rem;
  letter-spacing: 1px;
  color: ${Colors.ink};
`;

const Intro = styled.p`
  font-family: ${fonts.body};
  font-size: 0.98rem;
  line-height: 1.6;
  color: ${Colors.muted};
  max-width: 280px;
  margin: 0;
`;

const PhotoRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 2rem;
`;

const PhotoBlock = styled.div`
  width: 130px;
  height: 150px;
  background: ${Colors.lavender};
  border-radius: 14px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top center;
  }
`;

const Socials = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  a {
    font-family: ${fonts.body};
    font-size: 0.95rem;
    color: ${Colors.muted};
    text-decoration: none;
    transition: color 0.2s;
    &:hover {
      color: ${Colors.ink};
    }
  }
`;

const Big = styled.a`
  display: block;
  font-family: ${fonts.display};
  text-transform: uppercase;
  color: ${Colors.ink};
  text-decoration: none;
  line-height: 1.05;
  font-size: clamp(2rem, 8vw, 6.5rem);
  word-break: break-word;
  transition: color 0.2s;

  &:hover {
    color: ${Colors.lavender};
  }
`;

const Bottom = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 4rem;
  padding-top: 1.5rem;
  border-top: 1px solid ${Colors.line};
  font-family: ${fonts.body};
  font-size: 0.9rem;
  color: ${Colors.muted};

  @media (max-width: 560px) {
    flex-direction: column;
    gap: 0.5rem;
    align-items: flex-start;
  }
`;

const labelFromIcon = (icon = '') => {
  const key = icon.split('fa-').pop().trim();
  const map = {
    linkedin: 'LinkedIn',
    github: 'GitHub',
    twitter: 'Twitter / X',
    instagram: 'Instagram',
    behance: 'Behance',
  };
  return map[key] || key.charAt(0).toUpperCase() + key.slice(1);
};

const Footer = ({ followMe = [] }) => {
  const year = new Date().getFullYear();
  return (
    <Wrap>
      <Top>
        <div>
          <Brand>Santiago Estrada</Brand>
          <Intro style={{ marginTop: '1rem' }}>
            Systems engineer building scalable products. Let's turn your idea
            into a shipped system.
          </Intro>
        </div>
        <PhotoRow>
          <PhotoBlock className="gsap-fade-up">
            <img src="/img/profilephoto.png" alt="Santiago Estrada" />
          </PhotoBlock>
          <Socials>
            {followMe.map((item) => (
              <a key={item.id} href={item.link} target="_blank" rel="noreferrer">
                {labelFromIcon(item.icon)}
              </a>
            ))}
          </Socials>
        </PhotoRow>
      </Top>

      <Big className="gsap-fade-up" href="mailto:santiagoestrada.dev@gmail.com">
        santiagoestrada.dev@gmail.com
      </Big>
      <Big className="gsap-fade-up" href="tel:+573015219172">
        +57 301 521 9172
      </Big>

      <Bottom>
        <span>© {year} Santiago Estrada</span>
        <span>Designed &amp; built with care</span>
      </Bottom>
    </Wrap>
  );
};

export default Footer;
